import { Button } from '@material-ui/core';
import { ApplicationRoutes } from 'common/constants';
import React from 'react';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import LocalStorageService from 'services/LocalStorageService';

const DeleteLocalStorageButton = () => {
  const { t } = useTranslation();
  const history = useHistory();

  const handleLocalStorageRemoval = () => {
    LocalStorageService.removeState();
    history.push(ApplicationRoutes.Base);
    window.location.reload();
  };

  return (
    <Button variant="outlined" color="secondary" onClick={handleLocalStorageRemoval}>
      {t('delete_local_storage')}
    </Button>
  );
};

export default DeleteLocalStorageButton;
